import React from "react";

const sectionStyle = {
  backgroundColor: "#ffffff",
  border: "1px solid #d7dfea",
  borderRadius: "10px",
  padding: "16px",
  marginTop: "12px",
};

const headingStyle = {
  margin: "0 0 8px 0",
  color: "#1c2a40",
  fontSize: "18px",
};

const textStyle = {
  margin: "0",
  color: "#1c2a40",
  lineHeight: "1.6",
  fontSize: "14px",
};

export default function PrivacyPolicy() {
  return (
    <div style={{ backgroundColor: "#f3f6fa", minHeight: "100vh", padding: "24px" }}>
      <div style={{ maxWidth: "900px", margin: "0 auto" }}>
        <h1 style={{ margin: 0, color: "#1c2a40" }}>managd Privacy Policy</h1>
        <p style={{ ...textStyle, marginTop: "8px" }}>
          Last updated: February 23, 2026
        </p>
        <p style={{ ...textStyle, marginTop: "8px" }}>
          This Privacy Policy explains how managd collects, uses, stores, and discloses
          information when you use the managd web portal and mobile app for workforce
          management, allocations, timesheets, leave, tasks, and invoices.
        </p>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>1. Information We Collect</h2>
          <p style={textStyle}>
            We may collect account and profile details (such as name, email, phone number,
            role, and business details), work records (allocations, timesheets, leave,
            invoices, notes, and signatures), uploaded files (documents and site images),
            and technical data (device information, app logs, and push token).
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>2. Mobile Permissions</h2>
          <p style={textStyle}>
            The mobile app may request permissions including camera, photos/media/library,
            files/storage, and notifications. These are used for features such as taking or
            uploading profile and site images, attaching documents, and receiving work
            updates. Permissions are only used for in-app functionality and can be managed in
            your device settings.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>3. How We Use Information</h2>
          <p style={textStyle}>
            We use data to provide and operate the service, manage organisations and worker
            records, create and process timesheets and invoices, maintain security, provide
            support, and communicate operational updates.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>4. Sharing and Disclosure</h2>
          <p style={textStyle}>
            Data is shared with authorised users within your organisation and trusted service
            providers needed to run the platform (for example hosting, storage, push
            delivery, and authentication). We may also disclose data where required by law or
            to protect legal rights and platform security.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>5. Data Storage and Security</h2>
          <p style={textStyle}>
            Data is stored on cloud infrastructure and protected using reasonable technical
            and organisational safeguards. No method of transmission or storage is completely
            secure, but we work to reduce risk and protect information.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>6. Retention</h2>
          <p style={textStyle}>
            We retain information for as long as needed to provide services, support business
            recordkeeping requirements, resolve disputes, and comply with legal obligations.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>7. Your Choices and Rights</h2>
          <p style={textStyle}>
            Depending on your location, you may have rights to access, correct, or request
            deletion of personal information. You can also manage app permissions in your
            device settings and notification preferences in-app where available.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>8. Children</h2>
          <p style={textStyle}>
            managd is intended for business use and is not directed to children.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>9. International Processing</h2>
          <p style={textStyle}>
            Your information may be processed in countries outside your own where our service
            providers operate. We use reasonable steps to protect data during cross-border
            processing.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>10. Changes to This Policy</h2>
          <p style={textStyle}>
            We may update this Privacy Policy from time to time. Updates will be posted on
            this page with a revised effective date.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>11. Contact</h2>
          <p style={textStyle}>
            For privacy requests, contact your organisation administrator first. For platform
            privacy queries, contact the app operator at <strong>privacy@managd.au</strong>.
          </p>
        </section>
      </div>
    </div>
  );
}
